/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { SettingsGearIcon16Light } from './SettingsGearIcon16Light';
import { SettingsGearIcon16Regular } from './SettingsGearIcon16Regular';
import { SettingsGearIcon16Solid } from './SettingsGearIcon16Solid';
import { SettingsGearIcon20Light } from './SettingsGearIcon20Light';
import { SettingsGearIcon20Regular } from './SettingsGearIcon20Regular';
import { SettingsGearIcon20Solid } from './SettingsGearIcon20Solid';
import { SettingsGearIcon24Regular } from './SettingsGearIcon24Regular';
import { SettingsGearIcon24Solid } from './SettingsGearIcon24Solid';
import { SettingsGearIcon32Regular } from './SettingsGearIcon32Regular';
import { SettingsGearIcon64Regular } from './SettingsGearIcon64Regular';
var sizes = {
    16: {
        light: SettingsGearIcon16Light,
        regular: SettingsGearIcon16Regular,
        solid: SettingsGearIcon16Solid,
    },
    20: {
        light: SettingsGearIcon20Light,
        regular: SettingsGearIcon20Regular,
        solid: SettingsGearIcon20Solid,
    },
    24: {
        regular: SettingsGearIcon24Regular,
        solid: SettingsGearIcon24Solid,
    },
    32: {
        regular: SettingsGearIcon32Regular,
    },
    64: {
        regular: SettingsGearIcon64Regular,
    },
};
export var SettingsGearIcon = forwardRef('SettingsGearIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
